import { put, takeLeading } from 'redux-saga/effects';

import complaintApi from 'api/complaintApi';
import { apiErrorHandler, showSuccess } from 'utils';

import {
  GET_MANAGER_COMPLAINTS,
  GET_MANAGER_COMPLAINTS_FAILED,
  GET_MANAGER_COMPLAINTS_SUCCESS,
  GET_MANAGER_COMPLAINT_DETAIL,
  GET_MANAGER_COMPLAINT_DETAIL_FAILED,
  GET_MANAGER_COMPLAINT_DETAIL_SUCCESS,
  RESOLVE_MANAGER_COMPLAINT,
  RESOLVE_MANAGER_COMPLAINT_SUCCESS,
  RESOLVE_MANAGER_COMPLAINT_FAILED,
  REJECT_MANAGER_COMPLAINT,
  REJECT_MANAGER_COMPLAINT_SUCCESS,
  REJECT_MANAGER_COMPLAINT_FAILED,
} from './actionTypes';

function* getManagerComplaints({ payload }) {
  try {
    const response = yield complaintApi.getComplaints(payload);

    yield put({
      type: GET_MANAGER_COMPLAINTS_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_MANAGER_COMPLAINTS_FAILED,
    });
  }
}

function* getManagerComplaintDetail({ payload }) {
  try {
    const id = typeof payload === 'string' ? payload : payload?.id || payload?._id;
    const response = yield complaintApi.getComplaintDetail(id);

    yield put({
      type: GET_MANAGER_COMPLAINT_DETAIL_SUCCESS,
      payload: response.payload,
    });

    if (payload && typeof payload.callback === 'function') {
      payload.callback(response.payload);
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_MANAGER_COMPLAINT_DETAIL_FAILED,
    });
  }
}

function* resolveManagerComplaint({ payload }) {
  const { id, values, callback } = payload || {};
  try {
    const response = yield complaintApi.resolveComplaint(id, values);

    showSuccess('Duyệt khiếu nại thành công');

    yield put({
      type: RESOLVE_MANAGER_COMPLAINT_SUCCESS,
      payload: response.payload || response,
    });

    if (id) {
      yield put({
        type: GET_MANAGER_COMPLAINT_DETAIL,
        payload: id,
      });
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: RESOLVE_MANAGER_COMPLAINT_FAILED,
    });
  }
}

function* rejectManagerComplaint({ payload }) {
  const { id, values, callback } = payload || {};
  try {
    const response = yield complaintApi.rejectComplaint(id, values);

    showSuccess('Từ chối khiếu nại thành công');

    yield put({
      type: REJECT_MANAGER_COMPLAINT_SUCCESS,
      payload: response.payload || response,
    });

    if (id) {
      yield put({
        type: GET_MANAGER_COMPLAINT_DETAIL,
        payload: id,
      });
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: REJECT_MANAGER_COMPLAINT_FAILED,
    });
  }
}

export default function* managerComplaintSaga() {
  yield takeLeading(GET_MANAGER_COMPLAINTS, getManagerComplaints);
  yield takeLeading(GET_MANAGER_COMPLAINT_DETAIL, getManagerComplaintDetail);
  yield takeLeading(RESOLVE_MANAGER_COMPLAINT, resolveManagerComplaint);
  yield takeLeading(REJECT_MANAGER_COMPLAINT, rejectManagerComplaint);
}
